import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  CButton,
  CCardBody,
  CCardTitle,
  CCol,
  CForm,
  CFormInput,
  CRow,
} from '@coreui/react-pro'
import { useStore } from 'effector-react'
import { Divider } from 'antd'
import {
  $demoContest,
  $demoContestCreateStatus,
} from '../DemoContestForm/model'
import {
  $textsSetting,
  $textsSettingCreateStatus,
  getTextsSettingMounted,
  setTextsSettingForm,
  submitCreateTextsSetting,
  submitEditTextsSetting,
} from './model'

type Props = {
  mode: 'create' | 'edit'
}

export const TextsSettingForm: React.FC<Props> = ({ mode }) => {
  const [validated, setValidated] = useState(false)

  const { contestType, name } = useStore($demoContest)
  const demoContestCreateStatus = useStore($demoContestCreateStatus)
  const textsCreateStatus = useStore($textsSettingCreateStatus)
  const textsSettings = useStore($textsSetting)

  useEffect(() => {
    if (mode === 'edit') {
      getTextsSettingMounted()
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      if (mode === 'create') {
        submitCreateTextsSetting({
          ...textsSettings,
          contestId: String(demoContestCreateStatus.id),
          contestName: demoContestCreateStatus.contestName,
        })
      }
      if (mode === 'edit') {
        submitEditTextsSetting({ ...textsSettings, contestName: name })
      }
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    value = event.currentTarget.value

    setTextsSettingForm({
      ...textsSettings,
      [event.currentTarget.name]: value,
    })
  }

  if (textsCreateStatus.isSuccess && mode === 'create') {
    return (
      <CCardBody>
        Тексты уже созданы, вы можете добавить картинки на вкладке "Images"
      </CCardBody>
    )
  }

  return (
    <CCardBody>
      <CForm noValidate validated={validated} onSubmit={handleSubmit}>
        <CCardTitle className="mb-3">Content</CCardTitle>
        <CRow className="mb-3">
          <CCol sm={4}>
            <CFormInput
              type="text"
              name="name"
              value={textsSettings.name}
              onChange={handleChange}
              label="Contest name"
              required
            />
          </CCol>
          <CCol sm={4}>
            <CFormInput
              type="text"
              name="description"
              value={textsSettings.description}
              onChange={handleChange}
              label="Contest description"
              required
            />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol sm={4}>
            <CFormInput
              type="text"
              name="winnersInfoTitle"
              value={textsSettings.winnersInfoTitle}
              onChange={handleChange}
              label="Title for top winner banner"
              required
            />
          </CCol>
          <CCol sm={4}>
            <CFormInput
              type="text"
              name="winnersInfoPrizes"
              value={textsSettings.winnersInfoPrizes}
              onChange={handleChange}
              label="Prize for winners"
              required
            />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol sm={4}>
            <CFormInput
              type="text"
              name="winnersInfoFooter"
              value={textsSettings.winnersInfoFooter}
              onChange={handleChange}
              label="Type of prize for winner"
              required
            />
          </CCol>
          <CCol sm={4}>
            <CFormInput
              type="text"
              name="infoTradingInstruments"
              value={textsSettings.infoTradingInstruments}
              onChange={handleChange}
              label="Instruments"
              required
            />
          </CCol>
        </CRow>
        {contestType === 'event' && (
          <>
            <Divider />
            <CCardTitle className="mb-3">Event</CCardTitle>
            <CRow className="mb-3">
              <div className="bold mb-2">Team 1</div>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="firstFullName"
                  value={textsSettings.firstFullName}
                  onChange={handleChange}
                  label="Full name"
                  required
                />
              </CCol>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="firstName"
                  value={textsSettings.firstName}
                  onChange={handleChange}
                  label="Short name"
                  required
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <div className="bold mb-2">Team 2</div>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="secondFullName"
                  value={textsSettings.secondFullName}
                  onChange={handleChange}
                  label="Full name"
                  required
                />
              </CCol>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="secondName"
                  value={textsSettings.secondName}
                  onChange={handleChange}
                  label="Short name"
                  required
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="infoTitle"
                  value={textsSettings.infoTitle}
                  onChange={handleChange}
                  label="Title for the team prizes block"
                  required
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="infoPrizes"
                  value={textsSettings.infoPrizes}
                  onChange={handleChange}
                  label="Prize for choosing the right team"
                  required
                />
              </CCol>
            </CRow>
          </>
        )}
        <CButton className="mb-3" type="submit">
          Save
        </CButton>
      </CForm>
    </CCardBody>
  )
}
